export const pillars = [
  'Técnica',
  'Costos',
  'Fotografía',
  'Instagram',
  'Meta Ads',
  'Gestión',
];

export const tomos = [
  {
    n: 1,
    title: 'Mentalidad Emprendedora',
    desc: 'Del hobby al negocio: cómo reorganizar tu tiempo, tu espacio y tu cabeza para tratar tu tejido como una empresa desde el primer día. Aprendés a poner límites, manejar tiempos de entrega y separar las emociones del precio.',
  },
  {
    n: 2,
    title: 'Técnica Superior & Acabados Pro',
    desc: 'Los puntos, terminaciones y rellenos que hacen que tu amigurumi parezca de vitrina. Los detalles de costura, los ojos de seguridad y el relleno correcto que justifican cobrar el triple sin que nadie te cuestione el precio.',
  },
  {
    n: 3,
    title: 'Tu Cliente Ideal en Argentina',
    desc: 'A quién venderle para que nunca te pida descuento. Cómo identificar y encontrar el segmento de compradores que valora lo artesanal y paga sin regatear. El perfil exacto del cliente que querés atraer.',
  },
  {
    n: 4,
    title: 'Costos Reales & Precios Anti-Inflación',
    desc: 'Ingeniería de precios argentina: materiales, tiempo, packaging, envío y comisiones de Mercado Pago para no vender nunca más a pérdida. Cómo actualizar tus precios ante cada subida sin perder clientes.',
  },
  {
    n: 5,
    title: 'Identidad Visual & Marca Propia',
    desc: 'Cómo crear un nombre, logo y estética de feed que hagan que tus clientes te reconozcan al instante y confíen antes de preguntar el precio. Tu marca como diferencial que elimina la comparación con la competencia.',
  },
  {
    n: 6,
    title: 'Fotografía de Producto Pro con Celular',
    desc: 'Iluminación, fondos y escenografías con lo que ya tenés en casa. Las fotos que hacen que la gente diga "necesito uno" antes de ver el precio. El set up completo para crear un mini estudio fotográfico gratuito.',
  },
  {
    n: 7,
    title: 'Instagram Estratégico para Tejedoras',
    desc: 'Reels, Stories y Feed que atraen pedidos reales. El calendario de contenidos para tejedoras que no quieren vivir pegadas al celular pero necesitan que el algoritmo las muestre todos los días.',
  },
  {
    n: 8,
    title: 'Copywriting para Tejedoras',
    desc: 'Qué escribir en el caption, en la descripción del producto y en el MD para que el cliente diga "lo quiero" sin que tengas que convencer a nadie. Las frases exactas que convierten curiosos en compradores.',
  },
  {
    n: 9,
    title: 'Atención al Cliente & Cierre de Ventas',
    desc: 'El arte de cerrar ventas por WhatsApp: cómo responder consultas, manejar la objeción del precio y cobrar señas que aseguren el pedido antes de empezar a tejer. Nunca más trabajar y que te cancelen.',
  },
  {
    n: 10,
    title: 'Logística & Envíos en Argentina',
    desc: 'Cómo despachar a todo el país con Correo Argentino y Andreani. Packaging que protege, enamora y hace que el cliente vuelva a comprar. Cómo calcular el costo de envío sin perder margen ni cobrarle de más al cliente.',
  },
  {
    n: 11,
    title: 'Monotributo & Medios de Pago',
    desc: 'Cómo formalizarte sin complicarte: la categoría ideal de Monotributo para empezar y cómo cobrar con Mercado Pago, transferencia y tarjeta sin perder margen en comisiones. Tu negocio legal desde el día uno.',
  },
  {
    n: 12,
    title: 'Hoja de Ruta: Agenda Llena en 30 Días',
    desc: 'El plan diario para ir de "tejo para amigas" a "tengo lista de espera" en exactamente un mes. Checklist de implementación día a día con las acciones concretas que te llevan de cero a tu primera venta real.',
  },
];

export const tomoIncludes = [
  { label: 'Técnicas listas para aplicar', detail: 'Sin teoría innecesaria' },
  { label: 'Protocolos paso a paso', detail: 'Sin saltear etapas' },
  { label: 'Plantillas editables', detail: 'Listas para usar hoy' },
  { label: 'Ejemplos del mercado ARG', detail: 'Reales y actualizados 2026' },
  { label: 'Checklists de implementación', detail: 'Para no perderte nada' },
  { label: 'Cálculo con inflación real', detail: 'Actualizable en tiempo real' },
  { label: 'Scripts de venta por WhatsApp', detail: 'Las palabras exactas' },
  { label: 'Listo para aplicar desde hoy', detail: 'Sin curva de aprendizaje larga' },
];
